import { extendCrudApi } from '@/utils/api.js';

const categoriesApi = extendCrudApi({
  entityNameSingular: 'Category',
  entityNamePlural: 'Categories',
  entityPath: 'categories',
  extraTags: ['Subcategories'],
  extraEndpoints: (builder) => ({
    reorderCategories: builder.mutation({
      query: ({ data }) => ({
        url: '/categories/reorder',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: [{ type: 'Categories', id: 'LIST' }],
    }),
    updateCategory: builder.mutation({
      query: ({ id, data }) => ({
        url: `/categories/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, arg) => [{ type: 'Categories', id: arg.id }],
    }),
  }),
});

const subcategoriesApi = extendCrudApi({
  entityNameSingular: 'Subcategory',
  entityNamePlural: 'Subcategories',
  entityPath: 'subcategories',
  extraTags: ['Categories'],
  extraEndpoints: (builder) => ({
    getSubcategories: builder.query({
      query: ({ categoryId } = {}) => ({
        url: '/subcategories',
        method: 'GET',
        params: categoryId ? { category_id: categoryId } : {},
      }),
      providesTags: ['Subcategories'],
    }),
    createSubcategory: builder.mutation({
      query: ({ data }) => ({
        url: '/subcategories/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (result, error, arg) => {
        const tags = [
          { type: 'Subcategories', id: 'LIST' },
          { type: 'Categories', id: 'LIST' },
        ];
        if (arg?.data?.category_id) {
          tags.push({ type: 'Categories', id: arg.data.category_id });
        }
        return tags;
      },
    }),
    updateSubcategory: builder.mutation({
      query: ({ id, data }) => ({
        url: `/subcategories/${id}`,
        method: 'PUT',
        body: data,
      }),     
      invalidatesTags: (result, error, arg) => {
        const tags = [
          { type: 'Subcategories', id: arg.id },
          { type: 'Categories', id: 'LIST' },
        ];
        if (arg.data?.category_id) {
          tags.push({ type: 'Categories', id: arg.data.category_id });
        }
        if (result?.data?.category_id && result.data.category_id !== arg.data?.category_id) {
          tags.push({ type: 'Categories', id: result.data.category_id });
        }
        return tags;
      },
    }),
    deleteSubcategory: builder.mutation({
      query: ({ id }) => ({
        url: `/subcategories/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'Subcategories', id: arg.id },
        { type: 'Subcategories', id: 'LIST' },
        { type: 'Categories', id: 'LIST' },
      ],
    }),
    reorderSubcategories: builder.mutation({
      query: ({ data }) => ({
        url: '/subcategories/reorder',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: [
        { type: 'Subcategories', id: 'LIST' },
        { type: 'Categories', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetCategoriesQuery,
  useGetCategoryQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
  useReorderCategoriesMutation,
} = categoriesApi;

export const {
  useGetSubcategoriesQuery,
  useGetSubcategoryQuery,
  useCreateSubcategoryMutation,
  useUpdateSubcategoryMutation,
  useDeleteSubcategoryMutation,
  useReorderSubcategoriesMutation,
} = subcategoriesApi;

